export default "__VITE_ASSET__BQxM$9tY__"